<template>
  <div class="edit_product">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="language('productDetails.tab1')" name="1">
        <el-form label-width="260px" class="demo-ruleForm">
          <el-form-item label="Merchant ID" prop="pass">
            <div>{{ tabData.shopNum }}</div>
          </el-form-item>
        </el-form>
        <cc-form
          :config="tab1Config"
          v-model="tabData"
          ref="form1"
          labelWidth="260px"
          :rules="rules"
          size="medium"
        ></cc-form>
      </el-tab-pane>
      <el-tab-pane
        :label="language('setDetails.tab2')"
        name="2"
        v-if="show && tabData.type"
      >
        <cc-form
          :config="tab2Config"
          v-model="tabData"
          ref="form2"
          labelWidth="150px"
          :rules="rules"
          size="medium"
        ></cc-form>
      </el-tab-pane>

      <div class="button_wrap">
        <el-button type="primary" class="btn" @click="save">{{
          language("productDetails.save")
        }}</el-button>
      </div>
    </el-tabs>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
import imageList from "./imageList";
import ProductList from "./ProductList.vue";
export default {
  props: {
    editData: Object,
  },
  data() {
    return {
      tabData: { totalPrice: 0, mchProductPackageItems: [] },
      activeName: "1",
      tab1Config: {
        props: [
          {
            required: true,
            label: "Model ID",
            name: "mchProductId",
            type: "input",
          },
          {
            required: true,
            label: "Type",
            name: "type",
            type: "select",
            options: [
              {
                value: "BOOK",
                label: "BOOK",
              },
              {
                value: "NONBOOK",
                label: "Non Book",
              },
            ],
          },

          {
            required: true,
            label: "Product Cover",
            name: "cover",
            type: "uploadFileV2",
            fileType: "image",
            // uploaderConf: uploadUtils.configPublish,
            uploaderConf: uploadUtils.configPublishV2("/perm/sisProduct/"),
            fFormat: ["image/png", "image/jpeg"],
            // info: "比例為：3:1",
          },
          {
            required: false,
            label: "Product Image List",
            name: "imageList",
            type: "component",
            componentName: imageList,
          },
          {
            required: true,
            label: "Online Status",
            name: "saleStatus",
            type: "radio",
            options: [
              {
                val: "0",
                label: "Offline",
              },
              {
                val: "1",
                label: "Online",
              },
              {
                val: "2",
                label: "Invisible",
              },
            ],
          },
          {
            required: false,
            label: "Product Category Code",
            name: "shopCategories",
            type: "input",
            info: this.language("productDetails.shopcategoryTips"),
            // info: "門店分類，多個用','隔開",
          },
          {
            required: false,
            label: "Product Campaign Code",
            name: "shopCampaigns",
            type: "input",
          },
          // {
          //   // required: true,
          //   label: "Brand (Chi)",
          //   name: "brand",
          //   type: "input",
          // },
          // {
          //   required: false,
          //   label: "Brand (Eng)",
          //   name: "brandEn",
          //   type: "input",
          // },
          // {
          //   // required: true,
          //   label: "Recommend Retail Price(HKD)",
          //   name: "recommendPrice",
          //   type: "number",
          // },
          // {
          //   // required: true,
          //   label: "Selling Price(HKD)",
          //   name: "salePrice",
          //   type: "number",
          // },
          // {
          //   // required: true,
          //   label: "Product Cost(HKD)",
          //   name: "productCost",
          //   type: "number",
          // },
          // {
          //   required: false,
          //   label: "Original Price",
          //   name: "listPrice",
          //   type: "input",
          // },
          {
            required: false,
            label: "Original Price Currency",
            name: "originalPriceCurrency",
            type: "input",
          },
          {
            // required: true,
            label: "Product Name (Chi)",
            name: "name",
            type: "input",
          },
          {
            required: false,
            label: "Product Name (Eng)",
            name: "nameEn",
            type: "input",
          },
          {
            // required: true,
            label: "Product Short Name (Chi)",
            name: "shortName",
            type: "input",
          },
          {
            required: false,
            label: "Product Short Name (Eng)",
            name: "shortNameEn",
            type: "input",
          },
          {
            // required: true,
            label: "Short Description (Chi)",
            name: "summary",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Short Description (Eng)",
            name: "summaryEn",
            type: "textarea",
            rows: 10,
          },
          {
            // required: true,
            label: "Long Description (Chi)",
            name: "introduction",
            type: "textarea",
            rows: 10,
          },
          {
            required: false,
            label: "Long Description (Eng)",
            name: "introductionEn",
            type: "textarea",
            rows: 10,
          },
          // {
          //   required: false,
          //   label: "Video Link (YouTube ID)",
          //   name: "videoLink",
          //   type: "input",
          // },
          // {
          //   required: false,
          //   label: "Video Link Text (Chi)",
          //   name: "videoLinkText",
          //   type: "input",
          // },
          // {
          //   required: false,
          //   label: "Video Link Text (Eng)",
          //   name: "videoLinkTextEn",
          //   type: "input",
          // },
          // {
          //   // required: true,
          //   label: "Delivery Method",
          //   name: "deliveryMethod",
          //   type: "radio",
          //   options: [
          //     {
          //       val: "1",
          //       label: "Shop+Courier",
          //     },
          //     {
          //       val: "2",
          //       label: "Shop",
          //     },
          //     {
          //       val: "3",
          //       label: "Courier",
          //     },
          //   ],
          // },
          // {
          //   required: false,
          //   label: "Goods Collection Mode",
          //   name: "collectionMode",
          //   type: "radio",
          //   options: [
          //     {
          //       val: "1",
          //       label: "Self Delivered to dedicated Warehouse",
          //     },
          //     {
          //       val: "2",
          //       label: "Collected from Merchant",
          //     },
          //     {
          //       val: "3",
          //       label: "Direct Deliver from Merchant to Customer",
          //     },
          //   ],
          // },
          // {
          //   required: false,
          //   label: "Invoice Remarks (Chi)",
          //   name: "invoiceRemark",
          //   type: "textarea",
          //   rows: 10,
          // },
          // {
          //   required: false,
          //   label: "Invoice Remarks (Eng)",
          //   name: "invoiceRemarkEn",
          //   type: "textarea",
          //   rows: 10,
          // },
          // {
          //   // required: true,
          //   label: "Agent Type",
          //   name: "agentType",
          //   type: "radio",
          //   options: [
          //     {
          //       val: "1",
          //       label: "Agent/代理商",
          //     },
          //     {
          //       val: "2",
          //       label: "Sole Agent/獨家代理商",
          //     },
          //     {
          //       val: "3",
          //       label: "Distributor/經銷商",
          //     },
          //     {
          //       val: "4",
          //       label: "Sole Distributor/獨家經銷商",
          //     },
          //     {
          //       val: "5",
          //       label: "Others",
          //     },
          //   ],
          // },
          // {
          //   required: false,
          //   label: "Sales Territory",
          //   name: "saleTerritory",
          //   type: "radio",
          //   options: [
          //     {
          //       val: "1",
          //       label: "Online + Offline",
          //     },
          //     {
          //       val: "2",
          //       label: "Online Only",
          //     },
          //     {
          //       val: "3",
          //       label: "HK Only (Online + Offline)",
          //     },
          //     {
          //       val: "4",
          //       label: "HK Only (Online)",
          //     },
          //   ],
          // },
          // {
          //   required: false,
          //   label: "Quantity Limit by Order",
          //   name: "quantityLimitByOrder",
          //   type: "number",
          // },
        ],
      },

      tab2Config: {
        props: [
          {
            required: true,
            label: "Product List",
            name: "mchProductPackageItems",
            type: "component",
            componentName: ProductList,
          },
          {
            // required: true,
            label: "Total Price",
            name: "totalPrice",
            type: "input",
            disabled: true,
          },
          {
            required: true,
            label: "Selling Price",
            name: "salePrice",
            type: "input",
          },
        ],
      },
      tab2Data: {
        // salePrice: "",
        // totalPrice: 0,
        // mchProductPackageItems: [],
      },

      rules: {
        modelId: [
          {
            required: true,
            message: this.language("setDetails.modelId"),
            trigger: "blur",
          },
        ],
        shopNum: [
          {
            required: true,
            message: this.language("productDetails.shopNumTips"),
            trigger: "blur",
          },
        ],
        mchProductId: [
          {
            required: true,
            message: this.language("productDetails.machProductIDTips"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.language("productDetails.typeTips"),
            trigger: "blur",
          },
        ],
        categories: [
          {
            required: true,
            message: this.language("productDetails.categoryTips"),
            trigger: "blur",
          },
        ],
        saleStatus: [
          {
            required: true,
            message: this.language("productDetails.saleStatusTips"),
            trigger: "blur",
          },
        ],
        brand: [
          {
            required: true,
            message: this.language("productDetails.brandTips"),
            trigger: "blur",
          },
        ],
        recommendPrice: [
          {
            required: true,
            message: this.language("productDetails.recommendPriceTips"),
            trigger: "blur",
          },
        ],
        salePrice: [
          {
            required: true,
            message: this.language("productDetails.salePriceTips"),
            trigger: "blur",
          },
        ],
        productCost: [
          {
            required: true,
            message: this.language("productDetails.productCostTips"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.language("productDetails.nameTips"),
            trigger: "blur",
          },
        ],
        shortName: [
          {
            required: true,
            message: this.language("productDetails.shortNameTips"),
            trigger: "blur",
          },
        ],
        summary: [
          {
            required: true,
            message: this.language("productDetails.summaryTips"),
            trigger: "blur",
          },
        ],
        introduction: [
          {
            required: true,
            message: this.language("productDetails.introductionTips"),
            trigger: "blur",
          },
        ],
        deliveryMethod: [
          {
            required: true,
            message: this.language("productDetails.deliveryTips"),
            trigger: "blur",
          },
        ],
        agentType: [
          {
            required: true,
            message: this.language("productDetails.agentTypeTips"),
            trigger: "blur",
          },
        ],
        publisher: [
          {
            required: true,
            message: this.language("productDetails.publisherTips"),
            trigger: "blur",
          },
        ],
        pubDate: [
          {
            required: true,
            message: this.language("productDetails.pubDateTips"),
            trigger: "blur",
          },
        ],
        countryOfPublication: [
          {
            required: true,
            message: this.language("productDetails.countryOfPublicationTips"),
            trigger: "blur",
          },
        ],
        language: [
          {
            required: true,
            message: this.language("productDetails.languageTips"),
            trigger: "blur",
          },
        ],
        edition: [
          {
            required: true,
            message: this.language("productDetails.editionTips"),
            trigger: "blur",
          },
        ],
        contentAbstract: [
          {
            required: true,
            message: this.language("productDetails.contentAbstractTips"),
            trigger: "blur",
          },
        ],
        placeOfManufacturing: [
          {
            required: true,
            message: this.language("productDetails.placeOfManufacturingTips"),
            trigger: "blur",
          },
        ],
        weight: [
          {
            required: true,
            message: this.language("productDetails.weightTips"),
            trigger: "blur",
          },
        ],
        length: [
          {
            required: true,
            message: this.language("productDetails.lengthTips"),
            trigger: "blur",
          },
        ],
        depth: [
          {
            required: true,
            message: this.language("productDetails.depthTips"),
            trigger: "blur",
          },
        ],
        height: [
          {
            required: true,
            message: this.language("productDetails.heightTips"),
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: this.language("productDetails.coverTips"),
            trigger: "blur",
          },
        ],
        mchProductPackageItems: [
          {
            required: true,
            message: this.language("setDetails.mchProductPackageItemsTips"),
            trigger: "blur",
          },
        ],
      },
      show: false,
    };
  },
  watch: {
    tabData: {
      handler() {
        let totalPrice = 0;
        console.log(this.tabData, "this.tabData");
        if (
          this.tabData.mchProductPackageItems &&
          this.tabData.mchProductPackageItems.length > 0
        ) {
          for (
            let index = 0;
            index < this.tabData.mchProductPackageItems.length;
            index++
          ) {
            totalPrice = this.add(
              totalPrice,
              this.tabData.mchProductPackageItems[index].mchProduct.salePrice *
                1
            );
          }
          this.tabData.totalPrice = this.$utils.toFixedDigit(totalPrice, 2);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    add(arg1, arg2) {
      (arg1 = arg1.toString()), (arg2 = arg2.toString()); // 将传入的数据转化为字符串
      var arg1Arr = arg1.split("."), // 将小数的数据从小数点的位置拆开
        arg2Arr = arg2.split("."),
        d1 = arg1Arr.length == 2 ? arg1Arr[1] : "", // 获取第一个数的小数点的长度
        d2 = arg2Arr.length == 2 ? arg2Arr[1] : ""; // 获取第二个数的小数点的长度
      var maxLen = Math.max(d1.length, d2.length); // 获取小数点长度较大的值
      var m = Math.pow(10, maxLen); // 这里表示10的小数点长度次方 也就是说如果小数点长度为2 m的值就是100 如果小数点长度是3 m的值就是1000如果不懂请自行查找api
      var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen)); // 将小数转化为整数后相加在除掉两个数乘过的倍数然后去小数点较长的长度的小数位数
      var d = arguments[2]; // 第三个参数用户可以自行决定是否要传递 用来定义要保留的小数长度
      return typeof d === "number" ? Number(result.toFixed(d)) : result;
    },
    div(arg1, arg2) {
      var r1 = arg1.toString(),
        r2 = arg2.toString(),
        m,
        resultVal,
        d = arguments[2];
      m =
        (r2.split(".")[1] ? r2.split(".")[1].length : 0) -
        (r1.split(".")[1] ? r1.split(".")[1].length : 0);
      resultVal =
        (Number(r1.replace(".", "")) / Number(r2.replace(".", ""))) *
        Math.pow(10, m);
      return typeof d !== "number"
        ? Number(resultVal)
        : Number(resultVal.toFixed(parseInt(d)));
    },
    save() {
      let result;

      result = Promise.all([this.chekeForm("form1"), this.chekeForm("form2")]);

      result
        .then((res) => {
          let data = { ...this.tabData, ...this.tab2Data };

          if (data.salePrice) {
            data.salePrice = (data.salePrice * 1000) / 10;
          }
          console.log(data);
          //判斷是不是正確內容
          let showTips = false;
          for (
            let index = 0;
            index < data.mchProductPackageItems.length;
            index++
          ) {
            if (data.type == "BOOK") {
              if (data.mchProductPackageItems[index].mchProduct.type == "H") {
                showTips = true;
                break;
              }
            } else if (data.type == "NONBOOK") {
              if (data.mchProductPackageItems[index].mchProduct.type != "H") {
                showTips = true;
                break;
              }
            }
          }
          if (showTips) {
            this.$confirm("套裝內商品類型與套裝類型不一致", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              showCancelButton: false,
            })
              .then(() => {})
              .catch(() => {});
            return false;
          }
          this.ccRequest
            .do("admin/merchant/product/save", data, "POSTJSON")
            .then((res) => {
              this.$alert("待「一本」批核", "提示", {
                confirmButtonText: "確認",
                callback: (action) => {
                  this.$message.success(
                    this.language("productDetails.success")
                  );
                  this.$emit("success", true);
                },
              });
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.language("common.mustNotEmpty"));
        });
    },
    chekeForm(refName) {
      return new Promise((resolve, reject) => {
        this.$refs[refName]
          .validate()
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
  mounted() {
    this.tabData = { ...this.editData };
    if (this.editData.id) {
      this.tabData.mchProductPackageItems = [...this.editData.items];
    }
    console.log(this.tabData);
    this.show = true;
    this.$bus.$on("changeTotalPrice", (e) => {
      let totalPrice = 0;
      let tabData = { ...this.tabData };
      for (let index = 0; index < e.length; index++) {
        totalPrice = this.add(totalPrice, e[index].mchProduct.salePrice * 1);
      }
      tabData.totalPrice = this.$utils.toFixedDigit(totalPrice, 2);
      this.tabData = { ...tabData };
      console.log(this.tabData);
    });
  },
};
</script>
<style lang="scss">
.edit_product {
  .upload-btnV2 .upload-demo {
    margin-top: -19px !important;
  }
}
</style>